export class Util {
    static addClass(el, className) {
        const classList = className.split(' ');
        el.classList.add(...classList);
    }
  
    static removeClass(el, className) {
        const classList = className.split(' ');
        el.classList.remove(...classList);
    }
  
    static toggleClass(el, className, bool) {
        bool ? Util.addClass(el, className) : Util.removeClass(el, className);
    }
  
    static setAttributes(el, attrs) {
        for (const key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }
  
    static hasClass(el, className) {
        return el.classList.contains(className);
    }
  
    static getChildrenByClassName(el, className) {
        return Array.from(el.children).filter(child => Util.hasClass(child, className));
    }
  
    static getIndexInArray(array, el) {
        return Array.from(array).indexOf(el);
    }
}
  